import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '@/api';
import { UseQueryConfig } from '@/api/types';
import { ReleaseNotesQueryParams } from '@/api/apis/release-notes';
import { releaseNotesQueryKeys } from './release-notes.keys';

export const releaseNotesQueries = {
  list: (params?: ReleaseNotesQueryParams) =>
    queryOptions({
      queryKey: releaseNotesQueryKeys.list(params),
      queryFn: () => api.releaseNotes.getReleaseNotes(params),
    }),
  byId: (id: string) =>
    queryOptions({
      queryKey: releaseNotesQueryKeys.byId(id),
      queryFn: () => api.releaseNotes.getReleaseNoteById(id),
    }),
};

export const useReleaseNotesQuery = (params?: ReleaseNotesQueryParams, options?: UseQueryConfig) => {
  return useQuery({ ...releaseNotesQueries.list(params), ...options });
};

export const useReleaseNoteByIdQuery = (id: string) => {
  return useQuery(releaseNotesQueries.byId(id));
};
